/* eslint-disable no-undef */
import Vue from 'vue';
import axios from 'axios';

const axiosInstance = axios.create();
axiosInstance.defaults.headers.common['Accept-Language'] = (localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en');
axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';

// Add a response interceptor
const responseInterceptor = axiosInstance.interceptors.response.use(
    (response) => {
        return Promise.resolve(response);
    },
    (error) => {
        console.log('Intercepted error:', error);
        if (error && error.response && error.response.status && error.response.status === 401 && window.location.pathname !== '/auth') {
            if (Vue.prototype.$config.debug) {
                console.log('[ API ]', 'Cancelled /auth redirect');
            } else {
                window.location.href = '/auth';
            }
        }
        return Promise.reject(error);
    }
);

// Add a request interceptor
const requestInterceptor = axiosInstance.interceptors.request.use(
    (request) => {
        // Assign the refreshed token on every request.
        const token = window.localStorage.getItem('token');
        if (token) {
            request.headers['Authorization'] = 'Bearer ' + token;
        }
        const language = window.localStorage.getItem('lang');
        if (language) {
            request.headers['X-Language-Code'] = language.toUpperCase();
        }
        request.headers['X-Requested-With'] = 'XmlHttpRequest';
        return Promise.resolve(request);
    },
    (error) => {
        return Promise.reject(error);
    }
);

export { axiosInstance, responseInterceptor, requestInterceptor };



// WEBPACK FOOTER //
// ./src/api/index.js